import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    getUser() {

        const options = {
            method: 'get',
            url: `/umbraco/api/user/UserDetails`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    isUserLoggedIn() {

        const options = {
            method: 'get',
            url: `/umbraco/api/user/IsUserLoggedIn`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}